import * as React from 'react';

import SecondaryButtonFilterCompany from './TableFilter/FilterTable'
import InlineDatePickerDemo from './TableFilter/DateFilter'
import TypeFilter from '../../LicenseAdm/Elements/TableFilter/TypeFilter'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import './ContainerFilter.css'

export default function ResponsiveDialog() {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div className='ContaierFilterTable'>
      <Button variant="outlined" onClick={handleClickOpen}>
        Filtrar
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Selecione os filtros desejados"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
              <SecondaryButtonFilterCompany></SecondaryButtonFilterCompany>
              <InlineDatePickerDemo></InlineDatePickerDemo>
              <TypeFilter></TypeFilter>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancelar
          </Button>
          <Button onClick={handleClose} autoFocus>
            Filtrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}